import React, { useState, useRef, useEffect } from 'react'
import propTypes from 'prop-types'
import styled from '@emotion/styled';
import { Grid, Box } from '@mui/material';
import { get } from 'lodash';

import { theme } from '../../../themes/default-theme';
import Text from '../../typography';
import TabsUnderline from '../../ui/TabsUnderline';
import SeriesCard from '../../navigation/NewMainNav/SeriesCard';
import Slider from '../SsrSlider';
import { ReactSVG } from 'react-svg';
import useDynamicRefs from '../../../hooks/useDynamicRefs';

import chevronLeft from '../../../assets/icons/chevron-left.svg';
import chevronRight from '../../../assets/icons/chevron-right.svg';
import Cta from '../../ui/Cta'
import NextLink from '../../navigation/NextLink'
import CaravanCard from '../../navigation/CaravanCard';

// import Carousel from "react-multi-carousel";

const Container = styled.div`

`

const Heading = styled(props => {
    return <Text {...props} />
})`
    margin-bottom: 5px;
    text-align: center;
    ${theme.breakpoints.up("md")} {
        margin-bottom: 20px;
    }
  `

const SeriesCardContainer = styled.div`  
    width:100%;
    padding: 0 8px;
    margin-top: 25px;    

    .slick-dots {
        list-style: none;
        text-align: center;
        font-size: 0;
        text-align: center;
        padding: 0;

        li {
            display: inline-block;
            padding: 0 6px;

            &.slick-active {
                button {
                    background-color: ${theme.palette.vividBlue};
                }
            }

            &.slick-next,
            &.slick-prev {
                ${theme.breakpoints.down('md')} {
                    display: none;
                }
                button {
                    background-color: transparent;
                    padding: 0;
                }

                svg {
                    height: 10px;
                    width: auto;
                    position: relative;
                    top: 5px;
                    [stroke] {
                        stroke: #758094;
                    }
                }
            }

            svg {
                ${theme.breakpoints.down('md')} {
                    display: none;
                }
            }
        }

        button {
            cursor: pointer;
            width: 12px;
            height: 12px;
            border-radius: 12px;
            border: none;
            background-color: ${theme.palette.middleGrey};
            font-size: 0;
        }
    }

    .slick-track {
        display: flex !important;
        justify-content: center;
    }

    .slick-slide {
        height: inherit !important;
    }

    .slick-slide {
        > div {
            height: auto;
            ${props => props.rows === 2 && `
                height: 50%;    
            `}
            ${theme.breakpoints.up('md')} {
                height: 100%;
            }
        }
    }

    ${props => props.carouselLength < 5 &&
        `
        ${theme.breakpoints.up('lg')} {
            .slick-track {
                text-align: center;
            }
    
            .slick-slide {
                width: 25% !important;
                display: inline-block;
                vertical-align: top;
                float: none;
            }    
        }

        `
    }



`

const SeriesCardItemContainer = styled.div`
    ${props => (props.display === false || props.display === 'false') && `
    display: none!important;
    `}
    `

const SeriesCardItem = styled.div`

    ${props => (props.display === false || props.display === 'false') && `
        display: none!important;
    `
    }
    text-align: center;
    padding: 0 8px;
    margin-bottom: 15px;
    height: 100%;

    > div {
        margin-left: auto;
        margin-right: auto;
        max-width: 240px;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: flex-start;

        ${theme.breakpoints.up('md')} {
            max-width: 320px;
        }
    }
    * {
        text-align: center;
        justify-content: center;
    }

    .caravan-card-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
`

const CtasContainer = styled.div`
    font-size: 0;
    margin-top: 20px;
    text-align: center;
`
const CtaItem = styled.div`
    display: inline-block;
    margin-bottom: 14px;

    ${theme.breakpoints.down('sm')} {
        button {
            font-size: 15px;
        }
    }
`

const categoryCarouselDefaultPropSettings = {};

const CategoryCarousel = (props) => {
    props = {
        ...props,
        settings: typeof props.settings === "undefined" ? categoryCarouselDefaultPropSettings : props.settings
    };

    const [activeCategory, setActiveCategory] = useState(0);
    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
    // const slider = useRef();
    const [getRef, setRef] =  useDynamicRefs();

    // Handle window resize for responsive behavior
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        if (typeof window !== 'undefined') {
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, []);


    const {
        title,
        categories,
        settings,
        cta
    } = props

    const handleArrowClick = (type) => {

        const slider = getRef(activeCategory);
         
        if (slider && slider.current) {
            if (type === 'prev') {
                slider.current.slickPrev();
            } else {
                slider.current.slickNext();
            }
        }
    }

    const carouselLength = get(categories, `${[activeCategory]}.series`, []).length;

    const getDesktopSlickSettings = (categorySeriesLength) => {
        const slidesToShow = categorySeriesLength < 4 ? categorySeriesLength : 4;
        
        return {
            fade: false,
            dots: true,
            rows: 1,
            slidesToShow: slidesToShow,
            arrows: false,
            slidesToScroll: 1,
            infinite: false,
            appendDots: (dots) => {
                return (
                    <ul className="slick-dots">
                        <li className="slick-arrow slick-prev"><button onClick={() => handleArrowClick('prev')}><ReactSVG src={chevronLeft} /></button></li>
                        {dots}
                        <li className="slick-arrow slick-next"><button onClick={() => handleArrowClick('next')}><ReactSVG src={chevronRight} /></button></li>
                    </ul>
                )
            },
            ...settings
        }
    }

    const getMobileSlickSettings = (categorySeriesLength) => {
        const slidesToShow = categorySeriesLength > 1 ? 2 : 1;
        
        return {
            fade: false,
            dots: true,
            rows: categorySeriesLength > 3 ? 2 : 1,
            slidesToShow: slidesToShow,
            arrows: false,
            slidesToScroll: 1,
            infinite: false,
            appendDots: (dots) => {
                return (
                    <ul className="slick-dots">
                        <li className="slick-arrow slick-prev"><button onClick={() => handleArrowClick('prev')}><ReactSVG src={chevronLeft} /></button></li>
                        {dots}
                        <li className="slick-arrow slick-next"><button onClick={() => handleArrowClick('next')}><ReactSVG src={chevronRight} /></button></li>
                    </ul>
                )
            },
            ...settings
        }
    }

    const isMobile = windowWidth <= 840;

    // const responsive = {
    //     superLargeDesktop: {
    //       // the naming can be any, depends on you.
    //       breakpoint: { max: 4000, min: 3000 },
    //       items: 5
    //     },
    //     desktop: {
    //       breakpoint: { max: 3000, min: 1024 },
    //       items: 3
    //     },
    //     tablet: {
    //       breakpoint: { max: 1024, min: 464 },
    //       items: 2
    //     },
    //     mobile: {
    //       breakpoint: { max: 464, min: 0 },
    //       items: 1
    //     }
    // };

    console.log('categoriescategories', categories);

    return (
        <Container>
            <Grid container spacing={0} direction={'row'} wrap="nowrap" justifyContent={'space-between'} align={'flex-start'} >
                <Grid size={12}>
                    <Box px={2}>
                        {title &&
                            <Heading variant="h3" size="extraLarge" colour="charcoal" uppercase={true} weight={800}>{title}</Heading>
                        }
                        {categories &&
                            <TabsUnderline data={categories.map(item => {
                                return {
                                    ...item,
                                    title: item.category
                                }
                            })} activeIndex={activeCategory} onChange={e => setActiveCategory(e)} />
                        }
                    </Box>
                    <Box>
                        {(categories && categories.length > 0 && categories[activeCategory] && categories[activeCategory].series) &&
                            <SeriesCardContainer carouselLength={categories[activeCategory].series.length} rows={carouselLength > 4 ? 2 : 1}>

                                {/* <Carousel responsive={responsive}> */}

                                {categories.map((parent, i) => {
                                    const currentCategoryLength = (parent.series && parent.series.length) || 0;
                                    const isActive = activeCategory == i;

                                    const sliderSettings = isMobile ? getMobileSlickSettings(currentCategoryLength) : getDesktopSlickSettings(currentCategoryLength);
                                    console.log('currentCategoryLength', currentCategoryLength, 'isMobile', isMobile, 'windowWidth', windowWidth, sliderSettings);
                                    return (
                                        <SeriesCardItemContainer key={`category-${i}`} display={isActive ? true : false}>
                                            {isActive ? (
                                                <Slider
                                                    key={`active-slider-${i}-${currentCategoryLength}-${isMobile ? 'mobile' : 'desktop'}-${windowWidth}`} // Force re-render on resize
                                                    ref={setRef(i)}
                                                    settings={sliderSettings}
                                                    arrowProps={{
                                                        grey: false,
                                                        lightGrey: theme === 'dark' ? false : true,
                                                        darkGrey: theme === 'dark' ? true : false,
                                                        medium: true
                                                    }}
                                                >
                                                    {(parent.series && parent.series.length > 0) && parent.series.map((item, index) => {
                                                        return (
                                                            <SeriesCardItem key={item.id || index}>
                                                                <CaravanCard
                                                                    {...item}
                                                                    text={`See ${item.title} in stock:`}
                                                                    href={`${parent.cta.href}/${item.href}`}
                                                                    bottomBorder={false}
                                                                    textLinks={[{
                                                                        text: 'VIC',
                                                                        href: `${parent.cta.href}/vic${item.href}`
                                                                    },{
                                                                        text: 'NSW',
                                                                        href: `${parent.cta.href}/nsw${item.href}`
                                                                    },{
                                                                        text: 'QLD',
                                                                        href: `${parent.cta.href}/qld${item.href}`
                                                                    },{
                                                                        text: 'SA',
                                                                        href: `${parent.cta.href}/sa${item.href}`
                                                                    },{
                                                                        text: 'WA',
                                                                        href: `${parent.cta.href}/wa${item.href}`
                                                                    },{
                                                                        text: 'NT',
                                                                        href: `${parent.cta.href}/nt${item.href}`
                                                                    },{
                                                                        text: 'ACT',
                                                                        href: `${parent.cta.href}/act${item.href}`
                                                                    },{
                                                                        text: 'TAS',
                                                                        href: `${parent.cta.href}/tas${item.href}`
                                                                    }]}
                                                                    disableCompare={true}
                                                                    fullWidth={true}
                                                                    />
                                                            </SeriesCardItem>
                                                        )
                                                    })}
                                                </Slider>
                                            ) : (
                                                <div style={{display: 'none'}}>
                                                    {(parent.series && parent.series.length > 0) && parent.series.map((item, index) => {
                                                        return (
                                                            <div key={item.id || index}>
                                                                <CaravanCard
                                                                    {...item}
                                                                    text={`See ${item.title} in stock:`}
                                                                    href={`${parent.cta.href}/${item.href}`}
                                                                    bottomBorder={false}
                                                                    textLinks={[{
                                                                        text: 'VIC',
                                                                        href: `${parent.cta.href}/vic${item.href}`
                                                                    },{
                                                                        text: 'NSW',
                                                                        href: `${parent.cta.href}/nsw${item.href}`
                                                                    },{
                                                                        text: 'QLD',
                                                                        href: `${parent.cta.href}/qld${item.href}`
                                                                    },{
                                                                        text: 'SA',
                                                                        href: `${parent.cta.href}/sa${item.href}`
                                                                    },{
                                                                        text: 'WA',
                                                                        href: `${parent.cta.href}/wa${item.href}`
                                                                    },{
                                                                        text: 'NT',
                                                                        href: `${parent.cta.href}/nt${item.href}`
                                                                    },{
                                                                        text: 'ACT',
                                                                        href: `${parent.cta.href}/act${item.href}`
                                                                    },{
                                                                        text: 'TAS',
                                                                        href: `${parent.cta.href}/tas${item.href}`
                                                                    }]}
                                                                    disableCompare={true}
                                                                    fullWidth={true}
                                                                    />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            )}


                                            {parent.cta &&
                                                <CtasContainer>
                                                    <CtaItem>
                                                        <NextLink legacyBehavior href={parent.cta.href}>
                                                            <Cta inline>
                                                                {parent.cta.title}
                                                            </Cta>
                                                        </NextLink>
                                                    </CtaItem>
                                                </CtasContainer>
                                            }

                                        </SeriesCardItemContainer>
                                    )
                                })}
                                {/* </Carousel> */}
                                {/* <div className="slider-controls">
                                    <button ref={prev} type="button" className="slide-m-prev">prev</button>
                                    <div ref={dots} className="slide-m-dots"></div>
                                    <button ref={next} type="button" className="slide-m-next">next</button>
                                </div> */}
                                {/* <CustomDots>
                                    <li><button className="slick-prev slick-arrow"></button></li>
                                    {categories[activeCategory].series.map((item, index) => {
                                        return (
                                            <li key={item.id || index}>
                                                <button>{index}</button>
                                            </li>
                                        )
                                    })}
                                    <li><button className="slick-next slick-arrow"></button></li>
                                </CustomDots> */}
                            </SeriesCardContainer>
                        }
                    </Box >
                </Grid>
            </Grid>
        </Container>
    );
}

CategoryCarousel.propTypes = {
}

export default CategoryCarousel
